
import { Toaster } from 'react-hot-toast'

import { useAuthListener } from '@/stores/authStore';
import RoutesComponent from '@/routes';


function App() {
    useAuthListener();
 

  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          success: {
            style: {
              backgroundColor: "#3cbb02",
              color: "#fff",
            },
          },
          error: {
            style: {
              backgroundColor: "#ee4444",
              color: "#fff",
            },
          },
        }}
      />
      <RoutesComponent />
    </>
  )
}

export default App; 